<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="4"
                    :searchBtnColSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">现售单管理</span>
                        <span style="margin-left:10px;">下单时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            :clearable="false"
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width: 180px"
                            @on-change="onDateChange"></DatePicker>
                        <RadioGroup v-model="userType"
                            style="margin-left:10px;"
                            @on-change="onUserTypeChange">
                            <Radio label="F"> <span>外部客户</span></Radio>
                            <Radio label="E"> <span>内部客户</span></Radio>
                        </RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="info"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-send"
                            :loading="btnLoading"
                            @click="onExport()">导出</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <CurSaleOrderDetail ref="curSaleOrderDetailModal" />
        <CurSaleOrderDelivery ref="curSaleOrderDeliveryModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import CurSaleOrderDetail from './curSale-order-detail';
import CurSaleOrderDelivery from './curSale-order-delivery';
import { getCurSaleOrderList, exportCurSaleOrderList, deleteCurSaleOrder } from '@/api/modules/curSale-management/curSale-order';
import {
    getOrderDeliveryStatusOptions,
    getOrderPaidStatusOptions
} from '@/view/curSale-management/curSale-order/CurSaleOrderStatus';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { DOWNLOAD_SERVER } from '@/api/modules/files';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { SignContractForUser } from '@/api/modules/system-management/user-management';

export default {
    name: 'CurSaleOrderList',
    components: {
        StandPaginationTable,
        SearchCard,
        CurSaleOrderDetail,
        CurSaleOrderDelivery
    },
    data() {
        return {
            selectDates: [],
            btnLoading: false,
            mainTable: {
                tableColumns: [
                    { title: '定单编号', key: 'curSaleOrderRecordCode', width: 170, align: 'center' },
                    { title: '会员名称', key: 'userPersonName', width: 100, align: 'center' },
                    { title: '会员账号', key: 'userName', width: 80, align: 'center' },
                    { title: '会员手机', key: 'userPhone', width: 80, align: 'center' },
                    { title: '转运站', key: 'distributionStationName', width: 100, align: 'center' },
                    { title: '客户经理', key: 'customerManagername', width: 100, align: 'center' },
                    {
                        title: '定单合计', key: 'curSaleOrderRecordTotalOrderCost', width: 80, align: 'right',
                        render: (h, params) => {
                            const curSaleOrderRecordTotalOrderCost = params.row.curSaleOrderRecordTotalOrderCost ? params.row.curSaleOrderRecordTotalOrderCost : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(curSaleOrderRecordTotalOrderCost, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '转运站运费', key: 'curSaleOrderRecordStationDeliveryFee', width: 80, align: 'right',
                        render: (h, params) => {
                            const curSaleOrderRecordStationDeliveryFee = params.row.curSaleOrderRecordStationDeliveryFee ? params.row.curSaleOrderRecordStationDeliveryFee : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(curSaleOrderRecordStationDeliveryFee, 2, '￥'))
                            ]);
                        }
                    },
                    { title: '定单状态', key: 'curSaleOrderRecordOrderStatus', width: 80, align: 'center' },
                    { title: '支付状态', key: 'curSaleOrderRecordPaidStatus', width: 80, align: 'center' },
                    { title: '苗场状态', key: 'mainRecordSeedFarmShipStatus', width: 80, align: 'center' },
                    { title: '转运站状态', key: 'mainRecordStationShipStatus', width: 80, align: 'center' },
                    { title: '定单备注', key: 'curSaleOrderRecordRemark', width: 160, align: 'center' },
                    { title: '下单时间', key: 'curSaleOrderRecordCreateAt', width: 130, align: 'center', render: (h, params) => dateTimeRender(h, params.row.curSaleOrderRecordCreateAt) },
                    {
                        title: '详情',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.curSaleOrderDetailModal.showModal(params.row.curSaleOrderRecordUuid);
                                            }
                                        }
                                    }, '查看')
                                ]);
                            }
                        }
                    },
                    {
                        title: '操作',
                        key: 'action2',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            visibility: this.$checkAccessArray(['B', 'C']) && params.row.mainRecordSeedFarmShipStatus != '已发货' ? 'visible' : 'hidden'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.curSaleOrderDeliveryModal.showModal(params.row.curSaleOrderRecordUuid);
                                            }
                                        }
                                    }, '发货')
                                ]);
                            }

                        }
                    },
                    {
                        title: '合同',
                        key: 'action3',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        on: {
                                            click: () => {
                                                this.onSignContract(params.row.curSaleOrderRecordUuid, '现售');
                                            }
                                        }
                                    }, params.row.curSaleOrderRecordIsContractSignedForUser == 1 ? '下载' : '签署')
                                ]);
                            }
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '定单编号', type: 'Input', value: '', name: 'curSaleOrderRecordCode', sql: 'like' },
                    { label: '会员名称', type: 'Input', value: '', name: 'concat(userName,userPersonName)', sql: 'like' },
                    {
                        label: '支付状态',
                        type: 'Select',
                        value: [],
                        name: 'curSaleOrderRecordPaidStatus',
                        sql: 'in',
                        options: getOrderPaidStatusOptions()
                    },
                    {
                        label: '发货状态',
                        type: 'Select',
                        value: [],
                        name: 'curSaleOrderRecordShipStatus',
                        sql: 'in',
                        options: getOrderDeliveryStatusOptions()
                    },
                    {
                        label: '合同签署',
                        type: 'Select',
                        value: [],
                        name: 'curSaleOrderRecordIsContractSigned',
                        sql: 'in',
                        options: [{ key: '已签署', value: 1 }, { key: '未签署', value: 0 }]
                    },
                    { label: '产品', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    { label: '大类', type: 'Input', value: '', name: 'mainCategoryName', sql: 'like' },
                    { label: '小类', type: 'Input', value: '', name: 'subCategoryName', sql: 'like' },
                    { label: '产品形态', type: 'Input', value: '', name: 'productForm', sql: 'like' },
                    { label: '品牌', type: 'Input', value: '', name: 'brandName', sql: 'like' },
                    { label: '配送时间', type: 'Daterange', value: '', name: 'curSaleOrderDetailStationDeliveryDate', sql: 'dateBetween' }
                ]
            }
        };
    },
    props: {
        userType: { type: String, default: 'F' }
    },
    created() {
        if (this.$checkAccessArray(["G"]) === false) {
            const findIndex = this.mainTable.tableColumns.findIndex(c => c.title === "合同");
            if (findIndex >= 0) {
                this.mainTable.tableColumns.splice(findIndex, 1);
            }
        }
        if (this.$checkAccessArray(["B", "C"]) === false) {
            const findIndex = this.mainTable.tableColumns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.tableColumns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getMainTableRecords();
        },
        onSignContract(orderUuid, shoppingType) {
            this.mainTable.tableLoading = true;
            SignContractForUser({
                orderUuid: orderUuid,
                shoppingType: shoppingType
            }).then(res => {
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        window.open(res.data.signResult, "_blank");
                    }
                }
            });
        },
        onExport() {
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            exportCurSaleOrderList(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                        // window.open(FILE_SERVER + res.data.exportFileName, "_blank");
                    }
                }
            });
        },
        onUserTypeChange() {
            this.getMainTableRecords(true);
        },
        onDateChange() {
            this.getMainTableRecords(true);
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "userType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'userType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getCurSaleOrderList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    let curSaleOrderRecordTotalOrderCostTotal = 0;
                    let curSaleOrderRecordStationDeliveryFeeTotal = 0;
                    this.mainTable.tableData.forEach(e => {
                        curSaleOrderRecordTotalOrderCostTotal += e.curSaleOrderRecordTotalOrderCost;
                        curSaleOrderRecordStationDeliveryFeeTotal += e.curSaleOrderRecordStationDeliveryFee;
                    });
                    this.mainTable.tableData.push({
                        distributionStationName: '本页合计',
                        curSaleOrderRecordTotalOrderCost: numberToFixed(curSaleOrderRecordTotalOrderCostTotal, 2),
                        curSaleOrderRecordStationDeliveryFee: numberToFixed(curSaleOrderRecordStationDeliveryFeeTotal, 2),
                        action: -1
                    });
                    this.mainTable.tableData.push({
                        distributionStationName: '总合计',
                        curSaleOrderRecordTotalOrderCost: numberToFixed(res.data.sumData.sum_curSaleOrderRecordTotalOrderCost, 2),
                        curSaleOrderRecordStationDeliveryFee: numberToFixed(res.data.sumData.sum_curSaleOrderRecordStationDeliveryFee, 2),
                        action: -1
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>